export default class SoftSkill {
  title;
  constructor(data) {
    this.title = data?.title;
  }
}
